import React, { Component } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import MyPATLink from '../../common/MyPATLink'
import _ from "lodash";
import { LoginCaptcha, LoginRequestV2, SiteKey, UserEmail, UserEmpCode, UserMobile } from '../types/LoginRequestV2';
import config from '../../../config/config';
import { singleUserAxios } from '../../../services/axios';
import {
  WithStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import MyPATToaster from '../../common/MyPATToaster';
import CancelIcon from '@material-ui/icons/Cancel';
import userActionsV2 from '../actions/userActionsV2';
import { withRouter } from 'react-router-dom';
import { showMsg } from '../../../components/course/actions/loaderAlert';
import { VARIANT } from '../../common/types/ServerAlertDataV2';

const styles = (theme: Theme) =>
  createStyles({
    mainTitle: {
      fontSize: "24px",
      fontWeight: 400,
      lineHeight: "30px",
      marginBottom: "20px",
      marginTop: "30px",
    },
    subTitle: {
      fontSize: "16px",
      fontWeight: 600,
      display: 'block',
      lineHeight: "20px",
    },
    loginPwd: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: "30px",
      position: 'relative',
    },
    dropdownMenu: {
      minHeight: "50px",
      maxHeight: "200px",
      "overflow-y": "auto",
    },
  });
interface MyProps extends WithStyles<typeof styles> {
  loginSuccess: Function,
  loginData: any,
  showErrorToast: any,
  userData: any,
  clearErrorMsg: Function,
  location: any,
  history: any,
  showMsg: any,
  setUnregisteredDevice: any,
  showSuccessMessage: any,
  loginAfterDeviceRemoval: Function
}

export interface LoginFormState {
  form: LoginRequestV2,
  password: string,
  seconds: number,
  minutes: any,
  value: any,
  disable: boolean,
  reCaptcha: LoginCaptcha,
  siteKey: SiteKey,
  captchaError:boolean,
  captchaShow: boolean,
  withEmail: UserEmail,
  withMobile: UserMobile,
  withEmpCode: UserEmpCode,
  captchaChecked: boolean,
  reSendCaptcha: boolean,
  showResendButton: boolean,
  showErrorMsg: boolean,
  otpVerificationDone: boolean
}
class LoginWithOTP extends Component<MyProps, LoginFormState> {
  currentProps: MyProps;
  myInterval: any;
  constructor(props: MyProps, state: any) {
    super(props)
    this.currentProps = props;
    this.state = {
      form: {
        osType: 'web',
        device: 'desktop',
        appName: 'authors',
        password: '',
      },
      minutes: 0,
      seconds: 30,
      password: '',
      value: {
        otp1: "", 
        otp2: "", 
        otp3: "", 
        otp4: "",
      },
      reCaptcha: {
        loginCaptcha: ''
      },
      siteKey: {
        siteKey: config.captchaKey
      },
      withEmail: {
        appName: 'authors',
        email: '',
        captchaToken: '',
      },
      withMobile: {
        appName: 'authors',
        mobile: '',
        captchaToken: '',
        countryCode:  '',
      },
      withEmpCode: {
        appName: 'authors',
        empCode: '',
        captchaToken: '',
      },
      disable: true,
      captchaError: false,
      captchaShow: false,
      captchaChecked: false,
      reSendCaptcha: true,
      showResendButton: false,
      showErrorMsg: true,
      otpVerificationDone: false,
    }
    
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.resendOtpVerify = this.resendOtpVerify.bind(this);
    this.reCaptcha('');
    this.setState({ siteKey: this.state.siteKey.siteKey });
    this.setState({captchaShow: false});
    this.setState({captchaError: false});
    this.captchaGenerate();

    if (((this.currentProps || {}).loginData || {}).data === undefined) {
      window.location.href = '/login';
    }
  }

  captchaGenerate() {
    let captchaShow = false;
    if (!this.state.captchaChecked) {
      singleUserAxios.get(`v4/show-captcha`).then((res: any) => {
        if (res.data.showCaptcha) {
          captchaShow = true;
        }
      });
    }
  }

  handleChange(event: any) {
    const { name, value } = event.target;
    let valueData: any = this.state.value;
    valueData[name] = value;
    this.setState({value: valueData});
    if (valueData.otp1.length && valueData.otp2.length && valueData.otp3.length && valueData.otp4.length) {
      this.setState({showErrorMsg: false });
    } else {
      this.setState({showErrorMsg: true });
    }
  }

  handleSubmit(e: any) {
    localStorage.removeItem('backToForgot');
    e.preventDefault();
    if (this.currentProps.location.data.showUnregisterDeviceOtp) {

      const body = {
        userDeviceId: this.currentProps.location.data.deviceInfo.userDeviceId,
        otp: this.state.value.otp1 + this.state.value.otp2 + this.state.value.otp3 + this.state.value.otp4,
        osType: 'web',
        device: "desktop",
        empCode: this.props.loginData.data.username,
        appName: "authors",
        fingerprintId: ((this.props.loginData && this.props.loginData.data && this.props.loginData.data.deviceInfo) 
                        && this.props.loginData.data.deviceInfo.fingerprintId) || '',
        authenticateUserDevice: true,
        loginUser: true,
        currentDeviceFingerprintId: localStorage.getItem('visitorId')
      }
      singleUserAxios.post('v4/user-devices/verify-otp', body).then((res: any) => {
        if (res && res.code === 200) {
          if (res.data.userLoginData) {
            this.props.loginAfterDeviceRemoval(res.data.userLoginData);
          }
          const title = 'Yay! Device successfully Removed';
          const subTitle = `Your device ${this.currentProps.location.data.deviceInfo.removeDeviceInfo.device.name} has been removed from the registered device list`;
          this.props.showSuccessMessage(title, subTitle);
          if(this.props.location.data.deviceInfo.removeDeviceInfo.device.type !== 'desktop'){
            this.props.userData.unregisteredDevicesData.registeredDeviceList.splice(this.props.location.data.deviceInfo.removeDeviceInfo.index, 1);
            this.props.history.push({data: {
              ...this.props.location.data, 
              showUnregisterDeviceOtp: false,
              }
            })
          }
          else{
            this.props.setUnregisteredDevice(null);
            this.props.history.push({pathname: "/login", data: {
              username: this.currentProps.loginData.data.username, 
              type: this.currentProps.loginData.data.type, 
              countryCode: this.currentProps.loginData.data.countryCode, 
              countryFlag: this.currentProps.loginData.data.countryFlag,
              }
            });
          }
        } else {
          this.props.showMsg(res.message, 'error');
        }
      }).catch((err) => {
        this.props.showMsg(err.message, 'error');
      })

      return;
    }
    let currentState: any = {
      osType: 'web',
      device: 'desktop',
      appName: 'authors',
      captchaToken: this.currentProps.loginData.data.captchaToken ? this.currentProps.loginData.data.captchaToken : this.state.reCaptcha,
      otp: this.state.value.otp1 + this.state.value.otp2 + this.state.value.otp3 + this.state.value.otp4,
    }
    if (this.currentProps.loginData.data.type === 'empCode') {
      currentState.empCode = this.currentProps.loginData.data.username
    } else if (this.currentProps.loginData.data.type === 'mobile') {
      currentState.mobile = this.currentProps.loginData.data.username
      currentState.countryCode = this.currentProps.loginData.data.userDataPass.countryCode
    } else {
      currentState.email = this.currentProps.loginData.data.username
    }
    currentState.loginVia = this.currentProps.loginData.data.loginVia;
    this.props.loginSuccess(currentState)
    this.setState({ otpVerificationDone: true });
    
  }

  componentDidMount() {
    this.initTimer();
  }

  initTimer() {
    this.myInterval = setInterval(() => {
      const { seconds } = this.state
      if (seconds > 0) { 
        this.setState(({ seconds }) => ({
          seconds: seconds - 1
        }))
      } else if (seconds === 0) {
        this.setState({showResendButton: true, captchaChecked: false, captchaShow: false, captchaError: false});
        this.captchaGenerate();
        this.setState(({ seconds }) => ({
          seconds: 30
        }))
        clearInterval(this.myInterval);
      }
    }, 1000)
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  inputfocus = (elmnt: any) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {

        elmnt.target.form.elements[next].focus()
      }
    }
    else {
        const next = elmnt.target.tabIndex;
        if (next < 4) {
          elmnt.target.form.elements[next].focus()
        }
    }

  }

  reCaptcha = (value: any) => {
    this.setState({reCaptcha: value, captchaChecked: true, captchaError: false}, () => {
      this.resendOtpVerify('');
    });
  }

  resendOtpVerify(e?: any) {
    // e.preventDefault();
    this.setState({value: {otp1: '', otp2: '', otp3: '', otp4: ''}, otpVerificationDone: false});
      if (!this.state.captchaChecked ) {
        this.setState({captchaShow: true, captchaError: true})
      } else {
        this.setState({reSendCaptcha: false, captchaShow: false,});
        this.setState({showResendButton: false});
        clearInterval(this.myInterval);
        this.initTimer();
        if (this.currentProps.location.data.showUnregisterDeviceOtp) {
          const body = this.currentProps.location.data.deviceInfo;
          singleUserAxios.patch('v4/user-devices', body).then((res: any) => {
            if (res && res.code === 200) {
              this.props.history.push({ data: { 
                ...this.props.location.data,
                showUnregisterDeviceOtp: true,
                userDataPass: res.data,
              } });
            } else {
              this.props.showMsg(res.message, 'error');
            }
          }).catch((err) => {
            this.props.showMsg(err.message, 'error');
          })
          return;
        }
        let currentState: any = {
          osType: 'web',
          device: 'desktop',
          appName: 'authors',
          captchaToken: this.state.reCaptcha,
        }
        if (this.currentProps.loginData.data.type === 'email') {
            currentState.email = this.currentProps.loginData.data.username
        } else if (this.currentProps.loginData.data.type === 'mobile') {
          currentState.mobile = this.currentProps.loginData.data.username
        } else {
          currentState.empCode = this.currentProps.loginData.data.username
        }
        singleUserAxios.post(`v4/login/send-otp`, currentState).then((res: any) => {
        })
      }
  }

  backToLogin = () => {
    this.props.clearErrorMsg();
    if ((((this.currentProps || {}).loginData || {}).data || {}).showUnregisterDeviceOtp) {
      this.props.history.push({data: {
        ...this.props.location.data, 
        showUnregisterDeviceOtp: false,
        }
      })
      return;
    }
    this.props.history.push({pathname: "/login", data: {
      username: this.currentProps.loginData.data.username, 
      type: this.currentProps.loginData.data.type, 
      countryCode: this.currentProps.loginData.data.countryCode, 
      countryFlag: this.currentProps.loginData.data.countryFlag,
      }
    })
  }
  
  render() {
    const { minutes, seconds, siteKey } = this.state;
    const userLoginData = (((this.currentProps || {}).loginData || {}).data || {});
    const userMobile = (userLoginData.userDataPass || {}).mobile;
    const userEmail = (userLoginData.userDataPass || {}).email;
    const trailingUserInfo = userMobile + ((userMobile && userEmail) ? ' & ' : '') + userEmail;

    return (
      <>
        <div className="login-container">
          <em></em><em></em><em></em><em></em>
          <div className="sign-in-container">
              <div className="back-arrow" onClick={this.backToLogin}>
                <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 12l12 12.002 2.12-2.123L5.742 13.5H24v-3H5.742l8.378-8.379L12 0 0 12z" fill="#333" />
                </svg>
              </div>
            <img src="/assets/svg/authors-new-logo.svg" className="logoCms" alt="mypat logo" />
            <div className="signin-form forgotPwd">
              <h3 className='alignCenter'>Verification</h3>
              <div className='alignCenter'>
              {(((this.currentProps || {}).loginData || {}).data || {}).type === 'empCode' ? 
                <div>
                  <span className="infoEnter">
                    Please enter the 4-digit OTP sent to <span>{(((this.currentProps || {}).loginData || {}).data || {}).type === 'empCode' ? ((((this.currentProps || {}).loginData || {}).data || {}).userDataPass || {}).countryCode : ''} - {trailingUserInfo}</span>
                  </span>
                </div> : null
                }
                {(((this.currentProps || {}).loginData || {}).data || {}).type === 'email' || (((this.currentProps || {}).loginData || {}).data || {}).type === 'mobile' ?
                  <div>
                  <span className="infoEnter">
                    Please enter the 4-digit OTP sent to <span>{(((this.currentProps || {}).loginData || {}).data || {}).type === 'email' || (((this.currentProps || {}).loginData || {}).data || {}).type === 'mobile'  ? ((((this.currentProps || {}).loginData || {}).data || {}).userDataPass || {}).countryCode : ''} - {trailingUserInfo}</span>
                  </span>
                  </div> :  null }
              </div>

              {!((((this.currentProps || {}).loginData || {}).data || {}).showUnregisterDeviceOtp) && (
                <div className="editMobEmailEmp">
                {(((this.currentProps || {}).loginData || {}).data || {}).type !== 'email' ?
                  <i>{(((this.currentProps || {}).loginData || {}).data || {}).type === 'mobile' ? (((this.currentProps || {}).loginData || {}).data || {}).countryCode+ ' - ' : ''}{(((this.currentProps || {}).loginData || {}).data || {}).type === 'mobile' ? ((((this.currentProps || {}).loginData || {}).data || {}).userDataPass || {}).mobile : (((((this.currentProps || {}).loginData || {}).data || {}).userDataPass || {}).empCode)}</i>
                  :
                  <i>{this.currentProps.loginData.data.userDataPass.email}</i> }
                  <MyPATLink align="right" variant="body2" to={{pathname: '/login',state: { data: {username: this.currentProps.loginData.data.username, type: this.currentProps.loginData.data.type, countryCode: this.currentProps.loginData.data.countryCode, countryFlag: this.currentProps.loginData.data.countryFlag}}}}>
                  <img src="/assets/img/singleSignin/editIcon.svg" onClick={this.backToLogin}/>
                  </MyPATLink>
                </div>
              )}

              <form onSubmit={this.handleSubmit}>
                <div className={this.props.userData.showErrorMsg && this.state.otpVerificationDone ? 'otpInput error' : 'otpInput'}>
                  <b>
                    <input
                      name="otp1"
                      type="text"
                      autoComplete="off"
                      className="otpInput"
                      value={this.state.value.otp1}
                      //onKeyPress={this.keyPressed}
                      onChange={this.handleChange}
                      tabIndex={1} maxLength={1} onKeyUp={e => this.inputfocus(e)}

                    />
                  </b>
                  <b>
                    <input
                      name="otp2"
                      type="text"
                      autoComplete="off"
                      className="otpInput"
                      value={this.state.value.otp2}
                      onChange={this.handleChange}
                      tabIndex={2} maxLength={1} onKeyUp={e => this.inputfocus(e)}

                    />
                  </b>
                  <b>
                    <input
                      name="otp3"
                      type="text"
                      autoComplete="off"
                      className="otpInput"
                      value={this.state.value.otp3}
                      onChange={this.handleChange}
                      tabIndex={3} maxLength={1} onKeyUp={e => this.inputfocus(e)}

                    />
                  </b>
                  <b>
                    <input
                      name="otp4"
                      type="text"
                      autoComplete="off"
                      className="otpInput"
                      value={this.state.value.otp4}
                      onChange={this.handleChange}
                      tabIndex={4} maxLength={1} onKeyUp={e => this.inputfocus(e)}
                    />

                  </b>
                  {
                    this.props.userData.showErrorMsg && this.state.otpVerificationDone &&
                    <span className="error fixLeft">Invalid OTP</span>
                  }
                  
                </div>
                
                {this.state.showResendButton ?
                  <div className="resendOtp">
                    <a href="javascript:void(0);" onClick={this.resendOtpVerify}>Resend OTP</a>
                  </div> : <div className="otpTimer">00:{seconds < 10 ? `0${seconds}` : seconds}</div>
                }
                
                <div className="captcha-container1">
                {this.state.captchaShow ?
                  <div className="captcha">
                    <ReCAPTCHA
                      sitekey={siteKey.siteKey}
                      onChange={this.reCaptcha}
                    />
                  </div> : null
                }
                {this.state.captchaError ?
                  <div className="error">
                    <span>Please select captcha</span>
                  </div> : null
                }
                </div>
              

                <div className="input-group gapTwoBtn">
                  <button type="submit" disabled={this.state.showErrorMsg} className="submit-btn">
                    Verify
                  </button>
                </div>
              </form>
            </div>

          </div>
          <div className="sign-in-footer">
            <div className="footer-left">
              <p>&copy; Copyright 2024-2025 Edfora. All Rights Reserved</p>
            </div>
            <div className="footer-right">
              <a href="/terms-of-use"> Terms of Use</a> 
              <span>|</span> 
              <a href="/privacy-policy">Privacy Policy</a>
              <span>|</span>
              <a href="/disclaimer">Disclaimer</a>
              <span>|</span>
              <a href="/copyright">Copyright</a>
            </div>
          </div>
        </div>
        
        {( this.currentProps.showErrorToast &&
          <MyPATToaster 
           icon={<CancelIcon />}
           heading="Error"
           toasterAlignment="bottomRight"
           toasterType="error"
           subPara="Your license has been expired, please contact your supervisor for license renewal."
          />
        )}
      </>

    )
}
}

const mapStateToProps = (state: any) => ({
  showErrorToast: state.loginData.userData.showErrorToast,
  userData: state.loginData.userData
});

const mapDispatchToProps =  {
  clearErrorMsg: userActionsV2.removeError,
  showMsg,
  setUnregisteredDevice: userActionsV2.setUnregisteredDevice,
  loginAfterDeviceRemoval: userActionsV2.loginAfterDeviceRemoval,
  showSuccessMessage:(title: string, subTitle: string)=>(
    { 
      type: 'SHOW_ALERT', 
      data: {
        message: subTitle, 
        variant: VARIANT.SUCCESS, 
        openSnackbarV2: true,
        title
      }
    }
  )
};
//@ts-ignore
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(withRouter(LoginWithOTP)));
